import { useQuery } from '@tanstack/react-query';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api';

export const useQuestionnaires = () => {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: [adminLocalizationKeys.getAllQuestionnaires],
    queryFn: adminLocalizationApi.getAllQuestionnaires,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error
  };
};
